import createElementWithClass from 'ha/helpers/createElementWithClass';

export const H1 = createElementWithClass('h1', { defaultTag: 'h1' });
export const H2 = createElementWithClass('h2', { defaultTag: 'h2' });
export const H3 = createElementWithClass('h3', { defaultTag: 'h3' });
export const H4 = createElementWithClass('h4', { defaultTag: 'h4' });
export const H5 = createElementWithClass('h5', { defaultTag: 'h5' });
export const H6 = createElementWithClass('h6', { defaultTag: 'h6' });
